const MS_PER_DAY = 24 * 60 * 60 * 1000;

function toDateOnly(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function isSameCalendarDay(a, b) {
  return a.getFullYear() === b.getFullYear()
    && a.getMonth() === b.getMonth()
    && a.getDate() === b.getDate();
}

export function formatRelativeAge(fromDate, referenceDate = new Date()) {
  const from = toDateOnly(fromDate);
  const ref = toDateOnly(referenceDate);
  if (!from || !ref) return '';
  const fromDay = startOfDay(from);
  const refDay = startOfDay(ref);
  if (isSameCalendarDay(fromDay, refDay)) {
    return 'today';
  }
  const diffMs = refDay.getTime() - fromDay.getTime();
  if (diffMs < 0) return 'today';
  const days = Math.floor(diffMs / MS_PER_DAY);
  if (days < 30) {
    return days === 1 ? '1 day' : `${days} days`;
  }
  const months = Math.floor(days / 30);
  if (months < 24) {
    return months === 1 ? '1 month' : `${months} months`;
  }
  const years = Math.floor(days / 365);
  return years === 1 ? '1 year' : `${years} years`;
}

export function formatSeenDate(value, { referenceDate = new Date() } = {}) {
  const date = toDateOnly(value);
  if (!date) return 'N/A';
  const iso = date.toISOString().slice(0, 10);
  const relative = formatRelativeAge(date, referenceDate);
  return relative ? `${iso} (${relative})` : iso;
}

export function formatDurationSeen(firstSeen, lastSeen, referenceDate = new Date()) {
  const first = toDateOnly(firstSeen);
  if (!first) return 'N/A';
  const end = lastSeen ? toDateOnly(lastSeen) : toDateOnly(referenceDate);
  if (!end) return 'N/A';
  const fromDay = startOfDay(first);
  const endDay = startOfDay(end);
  const diffMs = endDay.getTime() - fromDay.getTime();
  if (diffMs < 0) return 'N/A';
  const days = Math.floor(diffMs / MS_PER_DAY);
  if (days === 0) return 'today';
  if (days < 30) {
    return days === 1 ? '1 day' : `${days} days`;
  }
  const months = Math.floor(days / 30);
  if (months < 24) {
    return months === 1 ? '1 month' : `${months} months`;
  }
  const years = Math.floor(days / 365);
  return years === 1 ? '1 year' : `${years} years`;
}
